<template>
  <div>
    <div class="table-actions">
      <Layout>
        <Column :size="innerWidth > 667 ? filterColumns : '12'" class="table-actions__filters">
          <slot name="leftFilters" />
          <div
            class="filter__table"
            v-if="
              (internalColumns.filter((x) => x.searchable).length !== 0 ||
                searchableColumns.length > 0) &&
              data.length
            "
          >
            <i class="mdi mdi-magnify"></i>
            <input type="text" :placeholder="customPlaceholder" v-model="filter" />
          </div>
          <slot name="rightFilters" />
        </Column>
        <Column
          align="right"
          :size="innerWidth > 667 ? actionColumns : '12'"
          class="table-actions__actions"
        >
          <slot name="actions" />
          <Button class="grid-add-button" icon="plus" @click="$emit('addNew')" v-if="showAdd">
            {{ addText }}
          </Button>
        </Column>
      </Layout>
      <div>
        <slot name="filters" />
      </div>
    </div>

    <div class="table" v-if="data.length">
      <table class="pw-datagrid" v-if="innerWidth > 667">
        <thead class="pw-datagrid__head">
          <tr>
            <th style="width: 30px" v-if="showDetailRow" />
            <th v-if="selectable" style="width: 30px; text-align: center">
              <Dropdown icon="menu-down" class="custom-dropdown">
                <DropdownItem @click="$emit('checkAll')"> Seleccionar todo </DropdownItem>
                <DropdownItem @click="$emit('checkCurrentPage', currentPage)">
                  Seleccionar página
                </DropdownItem>
                <DropdownItem @click="$emit('uncheckAll')"> Deseleccionar todo </DropdownItem>
                <DropdownItem @click="$emit('uncheckCurrentPage', currentPage)">
                  Deseleccionar página
                </DropdownItem>
              </Dropdown>
            </th>
            <th v-for="(column, index) in internalColumns" :key="index">
              <span v-html="column.title"></span>
            </th>
            <th style="width: 30px"></th>
          </tr>
        </thead>
        <tbody class="pw-datagrid__body">
          <template v-for="(item, index) in paginatedData">
            <tr
              :key="customKey === '' ? index : item[customKey]"
              v-if="$scopedSlots.default"
              class="pw-datagrid__row"
            >
              <td v-if="showDetailRow" class="pw-new-grid__actions">
                <div @click.stop="toggleDetails(item)">
                  <Button
                    color="transparent"
                    icon="chevron-right"
                    class="chevron-cell"
                    :class="{ 'is-expanded': isVisibleDetailRow(item) }"
                  />
                </div>
              </td>
              <td v-if="selectable" style="text-align: center">
                <CheckBox
                  class="custom-checkbox-grid"
                  @input="(state) => onSelectItem(item, state)"
                  v-model="item[selectableField]"
                />
              </td>
              <slot :row="item" :index="index" />
              <td class="pw-new-grid__actions">
                <Dropdown
                  position="bottom-right"
                  v-if="actions.length !== 0 || actionConditional.apply(null, [item]).length > 0"
                >
                  <DropdownItem
                    v-for="(action, actionIndex) in actions"
                    :key="actionIndex"
                    @click="() => action.callback.apply(null, [item])"
                  >
                    {{ action.text }}
                  </DropdownItem>
                  <DropdownItem
                    v-for="(action, actionIndex) in actionConditional.apply(null, [item])"
                    :key="actionIndex"
                    @click="() => action.callback.apply(null, [item])"
                  >
                    {{ action.text }}
                  </DropdownItem>
                </Dropdown>
              </td>
            </tr>
            <tr v-else class="pw-datagrid__row" :key="customKey === '' ? index : item[customKey]">
              <td v-if="showDetailRow" class="pw-new-grid__actions">
                <div @click.stop="toggleDetails(item)">
                  <Button
                    color="transparent"
                    icon="chevron-right"
                    class="chevron-cell"
                    :class="{ 'is-expanded': isVisibleDetailRow(item) }"
                  />
                </div>
              </td>
              <td v-if="selectable" style="text-align: center">
                <CheckBox
                  class="custom-checkbox-grid"
                  @input="(state) => onSelectItem(item, state)"
                  v-model="item[selectableField]"
                />
              </td>
              <td v-for="(column, index) in internalColumns" :key="index">
                <span v-html="getData(item, column)"></span>
              </td>
              <td class="pw-new-grid__actions">
                <Dropdown
                  position="bottom-right"
                  v-if="actions.length !== 0 || actionConditional.apply(null, [item]).length > 0"
                >
                  <DropdownItem
                    v-for="(action, actionIndex) in actions"
                    :key="actionIndex"
                    @click="() => action.callback.apply(null, [item])"
                  >
                    {{ action.text }}
                  </DropdownItem>
                  <DropdownItem
                    v-for="(action, actionIndex) in actionConditional.apply(null, [item])"
                    :key="actionIndex"
                    @click="() => action.callback.apply(null, [item])"
                  >
                    {{ action.text }}
                  </DropdownItem>
                </Dropdown>
              </td>
            </tr>

            <!-- eslint-disable-next-line -->
            <tr
              v-if="isActiveDetailRow(item)"
              class="border-bottom"
              :key="item"
            >
              <td :colspan="columnCount()">
                <div style="padding: 1rem">
                  <slot name="detail" :row="item" :index="index" />
                </div>
              </td>
            </tr>
            <slot v-if="isActiveCustomDetailRow(item)" name="detail" :row="item" :index="index" />
          </template>
        </tbody>
      </table>
      <template v-else>
        <div class="responsive-item" v-for="(item, index) in paginatedData" :key="index">
          <table class="grid-responsive-table">
            <tr v-for="(column, index) in internalColumns" :key="index">
              <th align="left">
                <span v-html="column.title"></span>
              </th>
              <td align="left">
                <span v-html="getData(item, column)"> </span>
              </td>
            </tr>
          </table>
          <Dropdown
            class="responsive-actions"
            position="bottom-right"
            v-if="actions.length !== 0 || actionConditional.apply(null, [item]).length > 0"
          >
            <div class="full-trigger" slot="trigger"></div>
            <DropdownItem
              v-for="(action, actionIndex) in actions"
              :key="actionIndex"
              @click="() => action.callback.apply(null, [item])"
            >
              {{ action.text }}
            </DropdownItem>
            <DropdownItem
              v-for="(action, actionIndex) in actionConditional.apply(null, [item])"
              :key="actionIndex"
              @click="() => action.callback.apply(null, [item])"
            >
              {{ action.text }}
            </DropdownItem>
          </Dropdown>
        </div>
      </template>
    </div>
    <Layout v-else>
      <Column size="4" />
      <Column :size="innerWidth > 667 ? 4 : 12">
        <ActionCard
          :image="require('../assets/blank.svg')"
          :text="customEmptyText"
          style="size: 100%"
        />
      </Column>
    </Layout>
    <div class="pagination" v-if="paginated">
      <Pagination
        v-if="filteredData.length !== 0"
        :totalItems="!paginatedByServer ? filteredData.length : totalItems"
        :pageSize="pageSize"
        @onChangePage="onChangePage"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import numbro from 'numbro';
import Layout from './Layout.vue';
import Column from './Column.vue';
import Button from './Button.vue';
import Dropdown from './Dropdown.vue';
import DropdownItem from './DropdownItem.vue';
import Pagination from './Pagination.vue';

export default {
  name: 'Grid',
  props: {
    selectable: {
      type: Boolean,
      default: false,
    },
    selectableField: {
      type: String,
      default: 'selected',
    },
    customKey: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    searchableColumns: {
      type: Array,
      default: () => [],
    },
    actions: {
      type: Array,
      default: () => [],
    },
    actionConditional: {
      type: Function,
      default: () => [],
    },
    addText: String,
    pageSize: {
      type: Number,
      default: 10,
    },
    paginated: {
      type: Boolean,
      default: true,
    },
    paginatedByServer: {
      type: Boolean,
      default: false,
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    customDetailKey: {
      type: String,
      default: '',
    },
    showAdd: {
      type: Boolean,
      default: true,
    },
    showDetailRow: {
      type: Boolean,
      default: false,
    },
    customDetailRow: {
      type: Boolean,
      default: false,
    },
    customPlaceholder: {
      type: String,
      default: 'Buscar',
    },
    customEmptyText: {
      type: String,
      default: 'No hay datos por mostrar',
    },
    filterColumns: {
      type: Number,
      default: 4,
    },
    actionColumns: {
      type: Number,
      default: 8,
    },
  },
  components: {
    Layout,
    Column,
    Button,
    Dropdown,
    DropdownItem,
    Pagination,
  },
  mounted() {
    this.$root.$on('reloadData', () => {
      this.$emit('reloadData');
    });
  },
  data() {
    return {
      innerWidth: window.innerWidth,
      currentPage: 1,
      isTable: true,
      internalColumns: this.columns || [],
      filter: '',
      opened: true,
      visibleDetailRows: [],
    };
  },
  methods: {
    getOtherActions(item) {
      return this.actionConditional.apply(null, [item]);
    },
    onSelectItem(item, state) {
      if (state) {
        this.$emit('checkItem', item);
      } else {
        this.$emit('uncheckItem', item);
      }
    },
    getData(item, column) {
      const field = item[column.field];

      if (column.format) {
        if (column.format === 'd') {
          return moment(field).format('DD/MM/YYYY');
        }
        if (column.format.includes('c')) {
          const zeros = column.format.replace('c', '');
          return numbro(field).formatCurrency({
            mantissa: Number(zeros || 0),
            thousandSeparated: true,
          });
        }
      }

      if (column.template) {
        if (typeof column.template === 'function') {
          return column.template.apply(null, [item]);
        }
      }

      return field;
    },
    onChangePage(page) {
      if (this.paginatedByServer) {
        this.$emit('changePage', page);
      } else {
        this.currentPage = page;
      }
    },
    columnCount() {
      return 1;
      // return (
      //   this.internalColumns.length +
      //   (this.actions == [] ? 0 : 1) +
      //   (this.actionConditional == [] ? 0 : 1) +
      //   (this.selectable ? 1 : 0) +
      //   (this.showDetailRow ? 1 : 0)
      // );
    },
    /**
     * Toggle to show/hide details slot
     */
    toggleDetails(obj) {
      const found = this.isVisibleDetailRow(obj);
      if (found) {
        this.closeDetailRow(obj);
        this.$emit('details-close', obj);
      } else {
        this.openDetailRow(obj);
        this.$emit('details-open', obj);
      }
      // Syncs the detailed rows with the parent component
      this.$emit('update:openedDetailed', this.visibleDetailRows);
    },

    openDetailRow(obj) {
      const index = this.handleDetailKey(obj);
      this.visibleDetailRows.push(index);
    },
    closeDetailRow(obj) {
      const index = this.handleDetailKey(obj);
      const i = this.indexOf(this.visibleDetailRows, index);
      this.visibleDetailRows.splice(i, 1);
    },
    isVisibleDetailRow(obj) {
      const index = this.handleDetailKey(obj);
      const result = this.indexOf(this.visibleDetailRows, index) >= 0;
      return result;
    },
    isActiveDetailRow(row) {
      return this.showDetailRow && !this.customDetailRow && this.isVisibleDetailRow(row);
    },
    isActiveCustomDetailRow(row) {
      return this.showDetailRow && this.customDetailRow && this.isVisibleDetailRow(row);
    },
    handleDetailKey(index) {
      const key = this.customDetailKey;
      return !key.length || !index ? index : index[key];
    },
    indexOf(array, obj) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] === obj) {
          return i;
        }
      }
      return -1;
    },
  },
  computed: {
    filteredData() {
      return this.data.filter((x) => {
        if (this.filter === '') {
          return true;
        }
        const columnsWithFilter = [
          ...this.internalColumns.filter((y) => y.searchable),
          ...this.searchableColumns,
        ]
          .map((y) => y.field)
          .filter((y) => y);
        return (
          columnsWithFilter
            .map((y) => {
              return String(x[y]).toLowerCase().includes(this.filter.toLowerCase());
            })
            .filter((y) => y).length !== 0
        );
      });
    },
    paginatedData() {
      if (this.data.length === 0) {
        return [];
      }
      return this.filteredData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.paginated ? this.currentPage * this.pageSize : this.data.length
      );
    },
  },
  watch: {
    columns(val) {
      this.internalColumns = val;
    },
  },
};
</script>

<style lang="scss">
@media (max-width: 667px) {
  .filter__table {
    width: 100%;
  }
  .grid-add-button {
    width: 100%;
    margin-top: 7px;
  }
  .grid-responsive-table {
    width: 100%;
    border: 1px solid #d8e3eb;
    th {
      font-weight: 600;
      background-color: #fff;
      padding: 8px;
    }
    td {
      font-weight: 400;
      padding: 8px;
    }
  }
  .responsive-item {
    display: flex;
    position: relative;
  }
  .responsive-item + .responsive-item {
    margin-top: 8px;
  }
  .responsive-actions {
    position: absolute;
    width: 100%;
    height: 100%;
    .pw-dropdown__menu {
      text-align: left !important;
      margin-top: 5px;
    }
    .full-trigger {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }
}

.filter__table {
  font-family: 'Nunito Sans', sans-serif !important;
  background-color: #f2f5f8;
  border: 1px solid #d5dbf3;
  border-radius: 3px;
  display: flex;
  padding: 4px;
  i {
    color: #89959e;
    margin-right: 8px;
  }
  input {
    background-color: transparent;
    border: 0;
    flex: auto;
    outline: none;
    &::placeholder {
      color: #89959e;
      font-size: 15px;
    }
  }
}
.custom-checkbox-grid {
  display: inline;
  .pw-inputcheck {
    padding: 0;
    top: 1px;
  }
}

.custom-dropdown {
  text-align: left;
  font-weight: 400;
  .pw-dropdown__trigger {
    background-color: #a4afb7;
    color: white;
  }
  .pw-button {
    padding: 0;
    height: 22px;
    width: 20px;
    color: white;
    font-size: 20px;
  }
}

.table-actions {
  margin-bottom: 8px;
  &__filters {
    display: flex;
    .filter__table {
      min-width: 250px;
    }
  }

  .pw-button {
    height: 32px;
    padding: 0.25rem 0.75rem;
  }
}
.table.hidden {
  display: none;
  block-size: 0px;
}
.sortable-ghost {
  td {
    background-color: rgba(91, 137, 242, 0.2) !important;
  }
}
.showDetailButton {
  cursor: pointer;
}
.pw-new-grid__actions {
  text-align: center;
  .pw-dropdown__menu {
    text-align: left !important;
  }
  .pw-button.pw-button-only-icon {
    width: auto !important;
    height: auto !important;
    padding: 0 !important;
  }
}
.pw-datagrid {
  width: 100%;
  &__head {
    th {
      color: #333333;
      line-height: 22px;
      font-weight: bold;
      background-color: #fff;
      border-top: 1px solid #d8e3eb;
      border-bottom: 1px solid #d8e3eb;
      padding: 8px;
    }
  }
  text-align: left;
  border-spacing: 0;
  &__head {
    th {
      color: #333333;
      line-height: 22px;
      font-weight: bold;
      background-color: #fff;
      border-top: 1px solid #d8e3eb;
      border-bottom: 1px solid #d8e3eb;
      padding: 8px;
    }
  }
  &__body {
    .pw-datagrid__row {
      &--draggable {
        cursor: move;
      }
      &:nth-child(2n + 1) {
        td {
          background-color: #fbfbfb;
        }
      }
      td {
        color: #333333;
        padding: 5px 8px;
        font-size: 14px;
        line-height: 19px;
        background-color: #fff;
        border-bottom: 1px solid #d8e3eb;
      }
      .chevron-cell {
        padding-top: 0;
        padding-bottom: 0;
        padding-right: 5px;
        margin-bottom: 0;
        .mdi {
          font-size: 18px;
        }
        &.is-expanded {
          transform: rotate(90deg);
        }
      }
    }
    .border-bottom {
      border-bottom: 1px solid #d8e3eb;
    }
  }
}
.pw-datagrid__row {
  transform: none !important;
  &[draggable] {
    cursor: move;
  }
}
</style>
